import api from '@/api';
import { API_BASE_URL } from '..';
import { PageResult } from '@/core/request/PageResult';
import {
  FinancialConfiguration,
  FinancialConfigurationRequest,
} from './FinancialConfiguration.types';

const CONTROLLER_URL = `${API_BASE_URL}/FinancialConfiguration`;

const financialConfigurationService = {
  async getFinancialConfigurationProfile() {
    const result = (await api.get(`${CONTROLLER_URL}/profile`, {})) as unknown;

    return result as PageResult<FinancialConfiguration>;
  },
  async updateFinancialConfigurationProfile(
    obj: FinancialConfigurationRequest,
  ) {
    const result = (await api.put(
      `${CONTROLLER_URL}/profile`,
      obj,
      null,
    )) as unknown;

    return result;
  },
};

export default financialConfigurationService;
